module.exports = __webpack_public_path__ + "img/28f59ba.png";